import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getTree = async (debouncedSearch, isTenantExist) => {
  return await request.get(
    `/RentPlace/tree`,
    { searchString: debouncedSearch , isTenantExist},
    'При объектов счётчиков произошла ошибка',
    []
  );
};

const useTreeData = (debouncedSearch, isTenantExist) =>
  useQuery(
    [queries.treeData, debouncedSearch, isTenantExist],
    () => getTree(debouncedSearch, isTenantExist),
    {
      placeholderData: [],
    }
  );


export default useTreeData;
